import API from 'services/API';

export const login = (creds) => API.post('/auth/login', creds);

export const forgotPassword = (data) => API.post('/auth/forgotten_password', data);

export const resetPassword = (token, data) => API.post(`/auth/reset_password/${token}`, data);

export default { login };
